export enum AnalyticsEvents {
  BUTTON_CLICKED = 'Button Clicked',
  LINK_CLICKED = 'Link Clicked',
  NAVIGATION_OPENED = 'Navigation Opened',
  PAGE_VIEWED = 'Page Viewed',
}
